import { render, staticRenderFns } from "./UpdateDirectDeliveryDialog.vue?vue&type=template&id=3905c5d9&scoped=true"
import script from "./UpdateDirectDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDirectDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateDirectDeliveryDialog.vue?vue&type=style&index=0&id=3905c5d9&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905c5d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3905c5d9')) {
      api.createRecord('3905c5d9', component.options)
    } else {
      api.reload('3905c5d9', component.options)
    }
    module.hot.accept("./UpdateDirectDeliveryDialog.vue?vue&type=template&id=3905c5d9&scoped=true", function () {
      api.rerender('3905c5d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UpdateDirectDeliveryDialog.vue"
export default component.exports